export const AUTH_ASSURANCE_ACTIONS = [
    'login',
    'first-login',
    'new-browser',
    'account-recovery',
    'invite-claim-binding',
    'provider-link',
    'provider-relink',
    'document-change',
    'payment-action',
    'profile-security-change',
];
const AUTH_ASSURANCE_ACTION_SET = new Set(AUTH_ASSURANCE_ACTIONS);
export function isAuthAssuranceAction(value) {
    return typeof value === 'string' && AUTH_ASSURANCE_ACTION_SET.has(value);
}
export function createMfaStepUpRemediationResponse(action) {
    return {
        error: 'auth_remediation_required',
        code: 'mfa_step_up_required',
        remediation: {
            type: 'mfa_step_up',
            action,
        },
    };
}
export function parseMfaStepUpRemediationResponse(value) {
    if (!isRecord(value))
        return null;
    const remediation = value['remediation'];
    if (!isRecord(remediation))
        return null;
    if (value['error'] !== 'auth_remediation_required' ||
        value['code'] !== 'mfa_step_up_required' ||
        remediation['type'] !== 'mfa_step_up' ||
        !isAuthAssuranceAction(remediation['action'])) {
        return null;
    }
    return createMfaStepUpRemediationResponse(remediation['action']);
}
export function createSourceSessionInactiveResponse() {
    return {
        error: 'authentication_required',
        code: 'source_session_inactive',
    };
}
export function parseSourceSessionInactiveResponse(value) {
    if (!isRecord(value) ||
        value['error'] !== 'authentication_required' ||
        value['code'] !== 'source_session_inactive') {
        return null;
    }
    return createSourceSessionInactiveResponse();
}
function isRecord(value) {
    return typeof value === 'object' && value !== null;
}
//# sourceMappingURL=auth-assurance-action.js.map